/**
 * Module-level store for server time offset.
 *
 * Uses a plain pub/sub pattern compatible with `useSyncExternalStore`.
 * No React context — only subscribing components re-render, and only when
 * `timeOffset` actually changes.
 */

interface ServerTimeState {
  timeOffset: number | null;
  lastSyncAt: Date | null;
  isSyncing: boolean;
}

interface Listener {
  (): void;
}

let state: ServerTimeState = {
  timeOffset: null,
  lastSyncAt: null,
  isSyncing: false,
};

const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((l) => l());
}

export const serverTimeStore = {
  getSnapshot: () => state,

  subscribe: (listener: Listener) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  setOffset: (offset: number) => {
    const isOffsetChanged = state.timeOffset !== offset;
    state = { ...state, timeOffset: offset, lastSyncAt: new Date() };

    if (isOffsetChanged) emit();
  },

  setSyncing: (isSyncing: boolean) => {
    if (state.isSyncing === isSyncing) return;
    state = { ...state, isSyncing };
    emit();
  },
};
